// src/utils/services/AdvancedMD/ehrNotes.js
import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";


// Rutas de tu backend (Swagger ya muestra /api/advancedmd/ehrnotes/add y /search)
const ADD_EHR_NOTE_URL = `${API_BASE_URL}/api/advancedmd/ehrnotes/addtest`;
const SEARCH_EHR_NOTES_URL = `${API_BASE_URL}/api/advancedmd/ehrnotes/search`;

/**
 * Inserta una nota clínica vía backend.
 * - payload: objeto EXACTO que retorna buildEhrNotePayload(...)
 * - NO envía Authorization ni cookies; el backend ya maneja todo.
 * Devuelve lo que responda el backend (normalmente: { id, createdate, rawXml }).
 */
export async function addEhrNote(payload) {
  try {
    const res = await axios.post(ADD_EHR_NOTE_URL, payload, {
      headers: { "Content-Type": "application/json" },
      // El backend devuelve JSON (nuestro servicio ya parsea el XML)
    });
    return res.data;
  } catch (err) {
    console.error("Error adding EHR note (backend):", err);
    // Bubble up para que el caller muestre toast, etc.
    throw err;
  }
}

/**
 * Consulta notas clínicas (getehrnotes) vía backend.
 * - payload: body con @action=getehrnotes (el que ya probaste en Swagger).
 * Devuelve { count, notes, rawXml } desde el backend.
 */
export async function searchEhrNotes(payload) {
  try {
    const res = await axios.post(SEARCH_EHR_NOTES_URL, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return res.data;
  } catch (err) {
    console.error("Error searching EHR notes (backend):", err);
    throw err;
  }
}
